import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  news: [],
  newsItem: null,
  loading: false,
  error: null
};

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    fetchNewsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNewsSuccess: (state, action) => {
      state.loading = false;
      state.news = action.payload;
      state.error = null;
    },
    fetchNewsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchNewsItemStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNewsItemSuccess: (state, action) => {
      state.loading = false;
      state.newsItem = action.payload;
      state.error = null;
    },
    fetchNewsItemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchNewsStart,
  fetchNewsSuccess,
  fetchNewsFailure,
  fetchNewsItemStart,
  fetchNewsItemSuccess,
  fetchNewsItemFailure
} = newsSlice.actions;

export default newsSlice.reducer; 